<div class="utilities-list-container">
    <mat-card class="utilities-card">
        <mat-card-header class="utilities-card-header">
            <mat-card-title class="utilities-card-title">Utilities</mat-card-title>
        </mat-card-header>
        <mat-card-content class="utilities-list-content">
            <div class="utilities-list" [@pageChangeAnimation]="displayedUtilities.length">
                @for (utility of displayedUtilities; track utility.title) {
                    <mat-card class="utility-item-card" [routerLink]="['/utilities', utility.route]">
                        <div class="utility-item-card-content">
                            <div class="utility-icon-container">
                                <mat-icon class="utility-icon">{{utility.icon}}</mat-icon>
                            </div>
                            <div class="utility-text-container">
                                <mat-card-title class="utility-title">{{utility.title}}</mat-card-title>
                                <mat-card-subtitle class="utility-subtitle">{{utility.subtitle}}</mat-card-subtitle>
                            </div>
                        </div>
                    </mat-card>
                }
            </div>
        </mat-card-content>
        <mat-card-actions>
            <div class="pagination-controls">
                <button mat-icon-button [disabled]="!canNavigateBack" (click)="navigatePage('prev')">
                    <mat-icon class="utility-app-icon">navigate_before</mat-icon>
                </button>
                <button mat-icon-button [disabled]="!canNavigateForward" (click)="navigatePage('next')">
                    <mat-icon>navigate_next</mat-icon>
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</div>